"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = getReturnElements;
function getReturnElements(payload) {
    var value = null;

    if (payload && payload.elements && payload.elements.length > 0) {
        value = payload.elements;
    }

    return value;
}